export function normalizeVersionSnapshot(snapshot, versionId) {
  const { project_id, version_number, captured_at, project_metadata, packets } = snapshot;

  const tabOrder = project_metadata.tab_order || [];

  const normalizedPackets = packets.map((p, index) => {
    const position = tabOrder.indexOf(p.packet_id);
    return {
      packet: {
        id: p.packet_id,
        ...p.fields,
      },
      premium_blocks: [],
      position: position === -1 ? index : position,
    };
  });

  return {
    project: {
      id: project_id,
      title: project_metadata.title,
      tab_order: tabOrder,
      settings: project_metadata.settings,
      project_metadata: project_metadata.project_metadata,
      is_favorite: project_metadata.is_favorite,
    },
    packets: normalizedPackets,
    is_owner: true,
    has_owner: true,
    can_edit: false,
    versionMeta: {
      versionId,
      versionNumber: version_number,
      capturedAt: captured_at,
    },
  };
}
